import { graphql } from 'gatsby'

const menuTreeFromPages = (nodes, content) => {
  const allMenuItems = nodes
    .filter(node => node.pageContext !== null && node.pageContext.show)
    .map(node => {
      return { path: node.path, ...node.pageContext }
    })

  const datoPages = allMenuItems
    .filter(item => item.hasParent === false && item.type === 'DatoCmsPage')
    .sort((a, b) => a.position - b.position)

  datoPages.forEach(parent => {
    const { treeChildren, path } = parent
    if (treeChildren.length > 0) {
      parent.treeChildren = treeChildren
        .filter(child => child.show)
        .map(child => ({
          ...child,
          path: `${path}${child.slug}/`
        }))
        .sort((a, b) => a.position - b.position)
    }
  })
  return [...datoPages]
}

export { menuTreeFromPages }

export const query = graphql`
  fragment MenuHelpersAllPages on SitePage {
    path
    pageContext
  }
`
